import BetSlipOdd from '@core/models/base/BetSlipOdd';
import {
    getOddStatusFromSgaOdd,
    SgaOddPriceDto,
    SgaOddStatusDto,
} from '../types/dtos/SgaOddPriceDto';

const doneOddStatuses: Record<SgaOddStatusDto, boolean> = {
    [SgaOddStatusDto.ACTIVE]: false,
    [SgaOddStatusDto.BLOCKED]: true,
    [SgaOddStatusDto.UNAVAILABLE]: false,
} as const;

const oddStatusesShownOnOffer: SgaOddStatusDto[] = [
    SgaOddStatusDto.ACTIVE,
    SgaOddStatusDto.BLOCKED,
];

export function transformSgaOddPrice(
    dto: SgaOddPriceDto,
): BetSlipOdd {
    const isFinished = doneOddStatuses[dto.status];
    const isLocked = dto.status !== SgaOddStatusDto.ACTIVE;
    const isShownOnOffer = oddStatusesShownOnOffer.includes(dto.status);
    const marketName = dto.legs.map(({ name }) => name).join(';');

    return {
        id: Number(dto.outcomeId),
        value: dto.price,
        name: marketName,
        isLocked,
        marketId: Number(dto.marketId),
        marketName,
        marketUuid: '',
        description: '',
        specialBetValue: '',
        isFinished,
        isShownOnOffer,
        isBonusable: false,
        isInPromotion: false,
        uuid: dto.sgaUuid,
        isSuperbet: true,
        legs: dto.legs.map(({ status, ...rest }) => ({
            ...rest,
            status: getOddStatusFromSgaOdd(status),
        })),
    };
}
